<template>
    <div class="px-0 px-sm-3 px-lg-0 w-layout-1020-limit mx-auto" id="news">
        <h4 class="text-title-color my-4">{{ $t("news") }}</h4>

        <div class="image-container">
            <img src="@/assets/1920/news1.jpg" alt="news1" @click="openModal(1)" />
            <img src="@/assets/1920/news2.jpg" alt="news2" @click="openModal(2)" />
            <img src="@/assets/1920/news3.png" alt="news3" @click="openModal(3)" />
        </div>

        <!-- 彈跳視窗 -->
        <div v-if="isModalOpen" class="modal" @click="closeModal">
            <div class="modal-content">
                <img :src="getImageSrc" alt="enlarged-image">
            </div>
        </div>
    </div>
</template>


<style scoped>
.image-container {
    display: flex;
    justify-content: space-between;
    gap: 20px; /* 設定圖片之間的間距 */
    margin: 0 20px; /* 左右留白 */
}

.image-container img {
    width: calc(33.33% - 13.33px); /* 調整寬度，讓圖片之間的間距和左右留白差不多 */
    height: auto;
    object-fit: contain; /* 保持圖片比例並裁剪以填滿 */
}

/* 彈跳視窗的樣式 */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7); /* 半透明黑色背景 */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: transparent; /* 確保內容背景透明，防止變白 */
}

.modal-content img {
    max-width: 65%;  /* 調整圖片最大寬度 */
    max-height: 65%; /* 調整圖片最大高度 */
    object-fit: contain; /* 保持圖片比例 */
    background-color: transparent; /* 確保圖片周圍沒有背景色 */
    box-shadow: none; /* 移除可能影響背景的陰影 */
}

@media (max-width: 768px) { /* 手機版 */
    .image-container {
        flex-direction: column;
        gap: 20px; /* 手機版圖片之間的間距 */
        margin: 0; /* 手機版取消左右留白 */
    }

    .image-container img {
        width: 100%; /* 手機版圖片滿版 */
    }
}
</style>

<script>
export default {
    data() {
        return {
            isModalOpen: false, // 彈窗是否開啟
            currentImage: null // 當前顯示的圖片
        };
    },
    methods: {
    openModal(imageNumber) {
        if (window.innerWidth > 768) { // 只在桌面版開啟彈窗
            this.isModalOpen = true;
            this.currentImage = imageNumber;
        }
    },
    closeModal() {
        this.isModalOpen = false;
        this.currentImage = null;
    }
    },
    computed: {
        getImageSrc() {
            switch (this.currentImage) {
                case 1:
                    return require('@/assets/1920/news1.jpg');
                case 2:
                    return require('@/assets/1920/news2.jpg');
                case 3:
                    return require('@/assets/1920/news3.png');
                default:
                    return '';
            }
        }
    }
};
</script>
